<template>
  <v-container class="pa-0">
    <CSATRating 
      page-name="Anotações" 
      :pergunta-id="10"
      :delay-seconds="5"
      @rating-submitted="onRatingSubmitted"
    />
    
    <v-row class="d-flex align-center">
      <v-col cols="12" sm="8" md="9">
        <v-text-field v-model="searchArquivos" clearable color="#6e6e6e" class="mt-0 pt-0"
          placeholder="Buscar em anotações" v-on:keyup.enter="onSearchClick">
          <template v-slot:append-outer>
            <v-btn text @click="onSearchClick"><v-icon class>mdi-magnify</v-icon> Buscar</v-btn>
          </template>
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" md="3" class="d-flex justify-end">
        <div class="anotacoes-toggle-bar">
          <v-icon class="mr-2 anotacoes-toggle-bar__icon">{{ viewMode === 'porLei' ? 'mdi-book-open-variant' : 'mdi-note-text' }}</v-icon>
          <span class="anotacoes-toggle-bar__label">{{ viewMode === 'porLei' ? 'Por lei' : 'Por anotação' }}</span>
          <v-switch
            v-model="viewPorAnotacao"
            hide-details
            class="anotacoes-toggle-bar__switch mt-0"
            color="#F15A24"
          ></v-switch>
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <!-- Modo: agrupado por lei -->
        <v-expansion-panels v-if="viewMode === 'porLei'">
          <v-expansion-panel v-for="(lei, index) in anotacoesPorLei" :key="index">
            <v-expansion-panel-header class="d-flex flex-column align-start ">
              <template v-if="lei.length && lei[0].id_lei">
                {{ typeof lei[0].id_lei === 'object' ? lei[0].id_lei.numero_lei : lei[0].id_lei }}
                <small v-if="typeof lei[0].id_lei === 'object' && lei[0].id_lei.nome_lei" class="mt-1">{{ lei[0].id_lei.nome_lei }}</small>
                <v-btn :to="`/painel/lei/${typeof lei[0].id_lei === 'object' ? lei[0].id_lei.id_lei : lei[0].id_lei}/${sanitizeTitle(typeof lei[0].id_lei === 'object' ? lei[0].id_lei.numero_lei : lei[0].id_lei)}`" text small
                  class="pl-0">Abrir lei</v-btn>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="annotation" v-for="a in lei" :key="a.id"
              style="background-color: #f5f5f5; padding: 20px 0px; border: 1px solid #d7d7d7;">
              <p v-if="a.id_reg && a.id_reg.conteudo" class="reg mx-0 "> {{ a.id_reg.conteudo }} </p>
              <p v-html="a.texto"></p>
              <p class="d-flex flex-column align-end ">
                <span>
                  <v-btn
                    v-if="a.id_reg && a.id_reg.id_reg"
                    text
                    :to="`/painel/lei/${typeof lei[0].id_lei === 'object' ? lei[0].id_lei.id_lei : lei[0].id_lei}/${sanitizeTitle(typeof lei[0].id_lei === 'object' ? lei[0].id_lei.numero_lei : lei[0].id_lei)}?id=${a.id_reg.id_reg}`">
                    <v-icon>mdi-arrow-right-top</v-icon> Ir até o registro</v-btn>
                  <v-btn
                    v-else
                    text
                    :to="`/painel/lei/${typeof lei[0].id_lei === 'object' ? lei[0].id_lei.id_lei : lei[0].id_lei}/${sanitizeTitle(typeof lei[0].id_lei === 'object' ? lei[0].id_lei.numero_lei : lei[0].id_lei)}`">
                    <v-icon>mdi-book-open-variant</v-icon> Abrir lei</v-btn>
                </span>
                <small class="pr-4">
                  <span v-if="a.status === `group`">
                    <v-icon>mdi-account-group</v-icon>
                    {{ a.id_grupo.nome_grupo }}
                  </span>
                  <span v-else>
                    <v-icon small>{{
                      a.status === `private`
                      ? `mdi-lock`
                      : `mdi-earth`
                    }}</v-icon>
                    {{ a.status | filterStatus }}
                  </span>
                  -
                  <v-icon small>mdi-clock-outline</v-icon>
                  {{ a.date_updated === null ? "Criado em" : "Atualizado em" }}
                  {{ a.date_updated === null ? a.date_created : a.date_updated | brdatetime }}
                </small>
              </p>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- Modo: lista por anotação (mais recente primeiro) -->
        <div v-else class="annotation-list">
          <div
            v-for="a in anotacoesOrdenadasPorData"
            :key="a.id"
            class="annotation-card mb-4"
          >
            <div v-if="a.id_lei" class="annotation-card__law mb-2">
              <strong>{{ typeof a.id_lei === 'object' ? a.id_lei.numero_lei : a.id_lei }}</strong>
              <v-btn
                v-if="typeof a.id_lei === 'object'"
                :to="`/painel/lei/${a.id_lei.id_lei}/${sanitizeTitle(a.id_lei.numero_lei)}`"
                text
                small
                class="ml-2 pl-0"
              >
                Abrir lei
              </v-btn>
            </div>
            <p v-if="a.id_reg && a.id_reg.conteudo" class="reg mx-0 mb-2">{{ a.id_reg.conteudo }}</p>
            <p v-html="a.texto"></p>
            <p class="d-flex flex-column align-end mt-2">
              <span>
                <v-btn
                  v-if="a.id_reg && a.id_reg.id_reg && a.id_lei"
                  text
                  :to="`/painel/lei/${typeof a.id_lei === 'object' ? a.id_lei.id_lei : a.id_lei}/${sanitizeTitle(typeof a.id_lei === 'object' ? a.id_lei.numero_lei : a.id_lei)}?id=${a.id_reg.id_reg}`"
                >
                  <v-icon>mdi-arrow-right-top</v-icon> Ir até o registro
                </v-btn>
                <v-btn
                  v-else-if="a.id_lei"
                  text
                  :to="`/painel/lei/${typeof a.id_lei === 'object' ? a.id_lei.id_lei : a.id_lei}/${sanitizeTitle(typeof a.id_lei === 'object' ? a.id_lei.numero_lei : a.id_lei)}`"
                >
                  <v-icon>mdi-book-open-variant</v-icon> Abrir lei
                </v-btn>
              </span>
              <small class="pr-4">
                <span v-if="a.status === 'group'">
                  <v-icon>mdi-account-group</v-icon> {{ a.id_grupo && a.id_grupo.nome_grupo ? a.id_grupo.nome_grupo : 'Grupo' }}
                </span>
                <span v-else>
                  <v-icon small>{{
                    a.status === 'private' ? 'mdi-lock' : 'mdi-earth'
                  }}</v-icon>
                  {{ a.status | filterStatus }}
                </span>
                -
                <v-icon small>mdi-clock-outline</v-icon>
                {{ a.date_updated === null ? 'Criado em' : 'Atualizado em' }}
                {{ (a.date_updated === null ? a.date_created : a.date_updated) | brdatetime }}
              </small>
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}

a {
  color: #F15A24 !important;
  text-decoration: none;
}

.annotation {
  border: 1px solid rgb(200 200 200);
  margin: 8px 0px;
  border-radius: 10px;
}

.reg {
  border: 1px dashed black;
  border-radius: 10px;
  padding: 5px;
}

.annotation-card {
  background-color: #f5f5f5;
  padding: 20px;
  border: 1px solid #d7d7d7;
  border-radius: 10px;
}

.annotation-card__law {
  color: #F15A24;
}

.anotacoes-toggle-bar {
  display: flex;
  align-items: center;
  border-radius: 8px;
  padding: 8px 12px;
  min-width: 200px;
  justify-content: space-between;
}

.anotacoes-toggle-bar__icon {
  color: #6e6e6e !important;
}

.anotacoes-toggle-bar__label {
  color: #333;
  font-size: 0.9rem;
  flex: 1;
}

.anotacoes-toggle-bar__switch {
  flex-shrink: 0;
}

.anotacoes-toggle-bar__switch ::v-deep .v-messages {
  display: none;
}
</style>
<script>
import CSATRating from '@/components/CSATRating.vue'

export default {
  name: "Anotacoes",
  components: {
    CSATRating
  },
  data() {
    return {
      viewMode: 'porLei',
      selected: 0,
      items: [],
      anotacoes: [],
      anotacoesArquivadas: [],
      anotacoesOrdenadasPorData: [],
      id_anotacao: null,
      anotacoesPorLei: {},
      loadingArquivos: false,
      searchArquivos: null,
      order: "DESC",
      page: 1,
      perPage: 5,
      totalPalavras: 0,
      totalPalavrasFiltrado: 0,
      buscou: false,
    };
  },
  mounted() {
    this.reloadAnotacoes()
    this.reloadAnotacoesArquivadas()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.reloadAnotacoes()
      vm.reloadAnotacoesArquivadas()
    })
  },
  beforeRouteUpdate(to, from, next) {
    this.reloadAnotacoes()
    next()
  },
  computed: {
    viewPorAnotacao: {
      get() { return this.viewMode === 'porAnotacao' },
      set(val) { this.viewMode = val ? 'porAnotacao' : 'porLei' },
    },
  },
  watch: {
    $route(to) {
      if (to.path.indexOf('anotacoes') !== -1) {
        this.reloadAnotacoes()
      }
    },
  },
  methods: {
    onRatingSubmitted(data) {
      window.console.log('Avaliação enviada:', data)
    },
    onSearchClick() {
      window.console.log('[Anotações] Buscando com termo:', this.searchArquivos)
      this.reloadAnotacoes()
    },
    reloadAnotacoes() {
      // Normalizar termo de busca (similar ao DialogAddVademecum)
      if (this.searchArquivos == null) this.searchArquivos = ''
      if (!isNaN(this.searchArquivos) && this.searchArquivos.indexOf('.') == -1) {
        this.searchArquivos = this.searchArquivos.replace(/(\d)(?=(\d{3})+$)/g, '$1.')
      }

      const search = this.searchArquivos && this.searchArquivos.trim()
        ? `&search=${encodeURIComponent(this.searchArquivos.trim())}`
        : ''

      // Buscar anotações excluindo aquelas que pertencem a vade-mécuns de grupos
      // Primeiro, buscar todas as anotações do usuário
      this.$http(`items/anotacoes?sort=-date_created&fields=*,id_reg.id_reg,id_reg.conteudo,id_lei.nome_lei,id_lei.numero_lei,id_lei.id_lei,id_vademecum.*&filter[user_created][_eq]=${this.$store.state.user.id}&filter[id_lei][_nnull]=true&filter[status][_neq]=archived${search}`).then(res => {
        this.anotacoesPorLei = {}
        
        // Filtrar anotações que não pertencem a vade-mécuns de grupos
        const anotacoesFiltradas = res.data.data.filter(anotacao => {
          // Se a anotação não tem vade-mécum, incluir
          if (!anotacao.id_vademecum) {
            return true
          }
          // Se a anotação tem vade-mécum mas o vade-mécum não tem id_grupo, incluir
          if (anotacao.id_vademecum && !anotacao.id_vademecum.id_grupo) {
            return true
          }
          // Se a anotação pertence a um vade-mécum de grupo, excluir
          return false
        })

        anotacoesFiltradas.forEach(el => {
          if (!el.id_lei) return
          const leiId = typeof el.id_lei === 'object' && el.id_lei.id_lei != null
            ? el.id_lei.id_lei.toString()
            : String(el.id_lei)
          if (this.anotacoesPorLei[leiId] === undefined) { this.anotacoesPorLei[leiId] = [] }

          this.anotacoesPorLei[leiId].push(el)
          if (el.id_reg) this.id_anotacao = el.id_reg
        })

        this.anotacoesOrdenadasPorData = anotacoesFiltradas
          .filter(el => el.id_lei)
          .sort((a, b) => {
            const dateA = a.date_updated || a.date_created || ''
            const dateB = b.date_updated || b.date_created || ''
            return dateB.localeCompare(dateA)
          })

        this.$forceUpdate()
      })
    },
    reloadAnotacoesArquivadas() {
      this.$http(`items/anotacoes?sort=-date_created&fields=*,id_lei.numero_lei,id_lei.id_lei&filter[user_created][_eq]=${this.$store.state.user.id}&filter[status][_eq]=archived`).then(res => {
        this.anotacoesArquivadas = res.data.data
      })
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
  }
}
</script>
